import { Injectable, inject } from '@angular/core';
import { AppSettingsService } from '../config/config-service';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  apiUrl: string | undefined;

  constructor(
    private http: CommonService,
    private appSettingsService: AppSettingsService,
  ) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }
  verifyEmail(tid: string, token: string) {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/api/auth/verify-email`, { tid, token });
  }

  forgotPassword(email: string) {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/api/auth/forgot-password`, { email });
  }
  resetPassword(tid: string, token: string, newPassword: string) {
    return this.http.post<{ success: boolean; error?: string }>(
      `${this.apiUrl}/api/auth/reset-password`,
      { tid, token, newPassword }
    );
  }

  requestEmailChange(newEmail: string) {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/api/auth/request-email-change`, { newEmail });
  }

  verifyEmailChange(token: string) {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/api/auth/verify-email-change`, { token });
  }
}